import React, { type InputHTMLAttributes, useEffect } from 'preact/compat'
import cn from 'classnames'
import formCss from '../../css/form.pcss.json'
import { loadStylesheet } from '../common/helpers'
import SVG from './SVG'

export default ({
  hasError,
  ...props
}: {
  hasError: boolean,
} & InputHTMLAttributes<HTMLInputElement>) => {
  const [type, setType] = React.useState('password')

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    loadStylesheet('form')
  }, [])

  const toggleType = () => {
    setType(type === 'password' ? 'text' : 'password')
  }

  return <div className={formCss['password-wrapper']}>
    <input
      type={type ?? 'password'}
      className={cn(formCss['input'], {
        [formCss['input--error']]: hasError
      })}
      {...props}
    />
    <button type='button' className={formCss['show-password-btn']} onClick={toggleType}>
      <SVG i={type==='password' ? 'sg-new/eye' : 'sg-new/eye-slash'} adaptive />
    </button>
  </div>
}
